import { Tabs } from "antd";
import CreateCheckList from "./CreateCheckListTab";
import CheckListReport from "./CheckListReportTab";
import { useState } from "react";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { useTranslation } from "react-i18next";
import { SearchInput } from "../../../components";

const CheckList = () =>{
  const { t } = useTranslation();
  const {width,height} = useWindowDimensions();
    const [Active, setActive] = useState();
    const items = [
      {
        key: "1",
        label: `${t("Create Checklist")}`,
        children: <CreateCheckList />,
      },
      {
        key: "2",
        label: `${t("Checklist Report")}`,
        children: <CheckListReport />,
      },
    ];
  
    const onChange = (key) => {
      console.log(key);
    };
    return(
        <div style={{margin: "0px 30px", width: "90%"}}>
     
        <Tabs
        className="tab_content_styling"
        size="large"
        defaultActiveKey="1"
        items={items}
        tabBarGutter={width > 570 ? 50 : 5}
        // centered
        onChange={onChange}
        tabBarStyle={width > 570  ? {
          color: "white",
          fontWeight: "bold",
          width: "100%",
          margin: "0px 40px"
        } : {
          color: "white",
          fontSize:'8px'
        } }
      />
        </div>
    )
};
export default CheckList;